import "./login.css";
import Footer from "../small/Footer";
import { Icon } from "@iconify/react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { Link, useNavigate } from "react-router-dom";
import {
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signInWithPopup,
  GoogleAuthProvider,
  FacebookAuthProvider,
} from "firebase/auth";
import { auth, app } from "../firebase";
import { useState } from "react";
import { toast } from "react-toastify";
const Login = () => {
  const [loginemail, setLoginEmail] = useState("");
  const [loginpassword, setLoginPassword] = useState("");
  const [user, setUser] = useState({});
  const history = useNavigate();

  const login = async (e) => {
    try {
      const user = await signInWithEmailAndPassword(
        auth,
        loginemail,
        loginpassword
      );
      toast("User Logged in Succesfully", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      history("/");
    } catch (error) {
      console.log(error);
      toast("Please Enter Correct Email/Passowrd", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  return (
    <>
      <main className="create-own-bg">
        <section className="login">
          <div className="container">
            <h2 className="main-tite">Login</h2>
            <div className="email-wrap">
              <h3 className="craete-tit">Email address :</h3>
              <input
                className="create-input-txt mt-2"
                placeholder="someone@email.com"
                type="email"
                onChange={(e) => setLoginEmail(e.target.value)}
              />
            </div>
            <div className="password-wrap">
              <h3 className="craete-tit">Password :</h3>
              <input
                className="create-input-txt mt-2"
                placeholder="Password"
                type="password"
                onChange={(e) => setLoginPassword(e.target.value)}
              />
            </div>

            <div className="buttons-wrapper">
              <button className="login-btn" onClick={login}>
                Login
              </button>
              <Link className="sign-up-btn" to="/signup">
                Sign up
              </Link>
            </div>
          </div>
        </section>
        <Footer />
      </main>
    </>
  );
};
export default Login;
